import { render, staticRenderFns } from "./YouTubeCard.vue?vue&type=template&id=7aa5b030&scoped=true"
import script from "./YouTubeCard.vue?vue&type=script&lang=js"
export * from "./YouTubeCard.vue?vue&type=script&lang=js"
import style0 from "./YouTubeCard.vue?vue&type=style&index=0&id=7aa5b030&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7aa5b030",
  null
  
)

export default component.exports